// src/Dashbaord.js
import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import Footer from './Footer';


function Dashbaord() {

    const [activeTab, setActiveTab] = useState('partners'); // Default to "partners"

    const [openIndex, setOpenIndex] = useState(0);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "js/script.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // Cleanup
        };
    }, []);

    const faqs = [
        {
            id: 1,
            question: "Is Youvati available in all locations?",
            answer:
                "We are rapidly expanding and already present in 850+ cities across India.",
        },
        {
            id: 2,
            question: "How can individuals benefit from Youvati?",
            answer:
                "Workshops, courses, branding resources, bookings, khata and more — all in one app.",
        },
        {
            id: 3,
            question: "What challenges does Youvati solve?",
            answer:
                "Digitization, customer acquisition, operations, and access to finance for micro-entrepreneurs.",
        },
    ];



    const handleToggle = (index) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };



    return (
        <>


            <div class="min-h-screen flex flex-col" style={{ backgroundColor: "#f6f5fa" }}>


                <header class="top-4 z-40 " style={{ marginTop: "10px" }}>
                    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div
                            class="bg-white/90 backdrop-blur ring-1 ring-black/5 rounded-[20px] md:rounded-[28px] px-3 sm:px-4 md:px-6">

                            <div class="flex items-center justify-between h-12">
                                <a href="#" class="flex items-center gap-2">
                                    <img src="assets/youvati_logo.png" alt="Youvati" class="w-auto" style={{ height: "2rem" }} />
                                </a>


                                <nav class="hidden md:flex items-center  text-sm" style={{ gap: "2.2rem", fontWeight: "600" }}>
                                    <Link to="/" class="text-[#7872F8] px-2 py-0.5 rounded-lg bg-[#F0EFFE]" >Home</Link>
                                    {/* <Link to="" class="hover:text-[#7872F8]">Partner with us</Link> */}
                                    <Link to="/aboutus" class="hover:text-[#7872F8]" >About us</Link>
                                    <Link to="/contactus" class="hover:text-[#7872F8]" >Contact us</Link>
                                </nav>


                                <a href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
                                    target="_blank">
                                    <div class="hidden md:flex items-center gap-2 rounded-xl border px-2.5 py-0.5 shadow-sm">
                                        <span class="font-bold text-sm">Download App</span>
                                        <img src="assets/arrow.png" alt="qr" class="h-6 w-6" />
                                    </div>
                                </a>


                                <button id="menuBtn"
                                    class="md:hidden inline-flex items-center justify-center rounded-xl border px-2 py-1"
                                    aria-controls="mobileMenu" aria-expanded="false" aria-label="Open Menu">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="w-5 h-5">
                                        <path fill-rule="evenodd"
                                            d="M3.75 5.25a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75zm0 6a.75.75 0 01.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>


                            <div id="mobileMenu" class="md:hidden hidden border-t border-black/5 pt-3 pb-3">
                                <nav class="flex flex-col gap-3 text-sm" style={{ fontWeight: "600" }}>
                                    <a class="text-[#7872F8] px-2 py-1 rounded-lg bg-[#F0EFFE] w-max" href="#home">Home</a>
                                    <a class="hover:text-[#7872F8]" href="#partners">Partner with us</a>
                                    <a class="hover:text-[#7872F8]" href="#about">About us</a>
                                    <a class="hover:text-[#7872F8]" href="#contact">Contact us</a>
                                    <a class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 w-max"
                                        href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN">
                                        <span class="font-bold">Download App</span>
                                        <img src="assets/arrow.png" class="h-6 w-6" />
                                    </a>
                                </nav>
                            </div>
                        </div>
                    </div>
                </header>



                {/* ===========================Main Coontent============================================ */}

                <main class="flex-1" id="home">

                    <section class="bg-[#F6F5FA]">
                        <div
                            class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16 lg:py-10 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
                            <div>
                                <button
                                    className="bg-[#E1E0FD] text-xs sm:text-sm px-3 sm:px-4 py-2 rounded-md"
                                    style={{ fontWeight: 600, color: '#2E2E2E' }}
                                >
                                    Join more than 15,000 like you
                                </button>
                                <h1 class="mt-4 font-syne"
                                    style={{
                                        fontWeight: 600,
                                        lineHeight: 1.15,
                                        fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                    }}
                                >
                                    The All‑In‑One Platform <span class="block">For Women
                                        <span
                                            class="inline-flex items-center gap-2 align-middle ml-2 mt-2 md:mt-0 bg-[#38357A] text-white rounded-full pl-3 pr-1 py-1">
                                            <span class="font-semibold" style={{ fontSize: "20px", lineHeight: "2rem" }}>4.5</span>
                                            <img src="assets/star.png" alt="stars" class="h-5 w-auto" />
                                            <img src="assets/groupimg.png" alt="stars" class="h-6 w-auto" />
                                        </span>
                                    </span>
                                    <span class="block">Entrepreneurs Ready</span>
                                    <span class="block">To Grow</span>
                                </h1>
                                <p class="p-lg text-[#5C5C5C] mt-6 max-w-xl">Youvati is a mobile super‑app to help women
                                    digitize, manage, and grow their micro‑enterprises.</p>
                                <div className="mt-6 flex flex-wrap gap-3">
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.empower.youvati&hl=en_IN"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 bg-[#7872F8] text-white rounded-full px-4 py-2 card"
                                        style={{ fontWeight: 500 }}
                                    >
                                        Download App
                                        <img src="assets/arrow2.png" className="h-7 w-7" alt="arrow" />
                                    </a>
                                    <a
                                        href="#partners"
                                        className="inline-flex items-center gap-2 rounded-full px-5 py-3 border card"
                                        style={{ borderColor: '#2E2E2E', fontWeight: 500 }}
                                    >
                                        Partner With Us
                                    </a>
                                </div>

                            </div>
                            <div class="relative">
                                <img src="assets/hero.gif" alt="Hero" class="w-full h-auto max-h-[450px] object-contain" />
                            </div>
                        </div>
                    </section>



                    <section class="py-12 md:py-16 lg:py-6">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div class="mb-6 sm:mb-8">
                                <h3 class="font-syne text-[#2E2E2E] text-2xl sm:text-3xl">
                                    <span class="bg-gradient-to-r from-[#938EFA] to-[#938EFA]/70 bg-clip-text text-transparent">
                                        Milestones
                                    </span>
                                    That Define Us

                                </h3>
                            </div>


                            <div class="mt-8 grid md:grid-cols-3 gap-6 lg:gap-8">

                                <div class="grid gap-6">
                                    <div class="card rounded-2xl bg-white p-6">
                                        <img src="assets/milestones_cities.png" class="h-16 w-auto mb-6" alt="cities" />
                                        <p class="h3 text-[#38357A] mb-1">850+</p>
                                        <p class="p-lg text-[#5C5C5C]">Cities where we have marked our presence</p>
                                    </div>
                                    <div class="card rounded-2xl bg-white p-6">
                                        <img src="assets/milestones_learners.png" class="h-16 w-auto mb-6" alt="learners" />
                                        <p class="h3 text-[#38357A] mb-1">10,000+</p>
                                        <p class="p-lg text-[#5C5C5C]">Skill Learners and 500+ Hours of Training Provided</p>
                                    </div>
                                </div>




                                <div
                                    className="relative rounded-2xl overflow-hidden"
                                    style={{
                                        backgroundImage: "url('assets/milestone_image_container.png')",
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        position: 'relative',
                                        backgroundSize: 'cover',
                                        height: '32rem'
                                    }}
                                >




                                </div>


                                <div class="grid gap-6">
                                    <div class="card rounded-2xl bg-white p-6">
                                        <img src="assets/milestones_funding.png" class="h-16 w-auto mb-6" alt="funding" />
                                        <p class="h3 text-[#38357A] mb-1">₹40 Lakh+</p>
                                        <p class="p-lg text-[#5C5C5C]">Funding Provided to 250+ Micro‑entrepreneurs</p>
                                    </div>
                                    <div class="card rounded-2xl bg-white p-6">
                                        <img src="assets/milestones_branding.png" class="h-16 w-auto mb-6" alt="branding" />
                                        <p class="h3 text-[#38357A] mb-1">1500+</p>
                                        <p class="p-lg text-[#5C5C5C]">Branding & Marketing requests serviced</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section class="py-12 md:py-16 lg:py-14 bg-white/50" id="features">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">


                            <div class="mb-6 sm:mb-8">
                                <h3 class="font-syne [#2E2E2E] text-2xl sm:text-3xl" style={{ fontWeight: "700" }}>
                                    App
                                    <span class="bg-gradient-to-r from-[#938EFA] to-[#938EFA]/70 bg-clip-text text-transparent">
                                        Features
                                    </span>
                                </h3>
                            </div>


                            <div class="relative">


                                <article className="card rounded-3xl bg-white p-6 md:p-8 mb-6 sm:mb-0 sticky top-2 sm:top-4 z-10">
                                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                                        <img
                                            src="assets/features_learn.png"
                                            alt="learn"
                                            className="rounded-2xl h-auto"
                                            style={{ maxHeight: '28rem' }}
                                        />

                                        <div>
                                            <span className="inline-block bg-[#FFE9EB80] text-[#C9404B] font-bold rounded-full px-4 py-1">
                                                Learn
                                            </span>

                                            <h3
                                                className="mt-4"
                                                style={{
                                                    fontWeight: 600,
                                                    lineHeight: 1.15,
                                                    fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                                }}
                                            >
                                                Workshop & Courses
                                            </h3>

                                            <p className="p-lg text-[#5C5C5C] mt-3">
                                                Transform your passion into expertise. Access live workshops & courses
                                                led by industry experts. Earn certifications through structured courses.
                                            </p>

                                            <a
                                                href="#"
                                                className="mt-6 inline-flex items-center gap-2 border px-4 py-2 font-bold card"
                                                style={{ borderRadius: '1.75rem', borderColor: 'black' }}
                                            >
                                                Learn More
                                                <img src="assets/arrow.png" className="h-7 w-7" alt="arrow" />
                                            </a>
                                        </div>
                                    </div>
                                </article>



                                <article className="card rounded-3xl bg-white p-6 md:p-8 mb-6 sm:mb-0 sticky top-6 sm:top-12 -mt-12 sm:-mt-20 z-20">
                                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                                        <img
                                            src="assets/features_grow.png"
                                            className="rounded-2xl h-auto"
                                            alt="Grow"
                                            style={{ maxHeight: '28rem' }}
                                        />

                                        <div className="order-2 lg:order-1">
                                            <span className="inline-block bg-[#FFA5551A] text-[#BF6312] font-bold rounded-full px-4 py-1">
                                                Grow
                                            </span>

                                            <h3
                                                className="mt-4"
                                                style={{
                                                    fontWeight: 600,
                                                    lineHeight: 1.15,
                                                    fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                                }}
                                            >
                                                Readymade, DIY & Studio
                                            </h3>

                                            <p className="p-lg text-[#5C5C5C] mt-3">
                                                Access premium design resources. Get expert and tailored design
                                                services. Stand out from the competition.
                                            </p>

                                            <a
                                                href="#"
                                                className="mt-6 inline-flex items-center gap-2 border px-4 py-2 font-bold card"
                                                style={{ borderRadius: '1.75rem', borderColor: 'black' }}
                                            >
                                                Learn More
                                                <img src="assets/arrow.png" className="h-7 w-7" alt="arrow" />
                                            </a>
                                        </div>
                                    </div>
                                </article>




                                <article className="card rounded-3xl bg-white p-6 md:p-8 mb-6 sm:mb-0 sticky top-10 sm:top-20 -mt-12 sm:-mt-20 z-30">
                                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                                        <img
                                            src="assets/features_manage.png"
                                            alt="learn"
                                            className="rounded-2xl h-auto"
                                            style={{ maxHeight: '28rem' }}
                                        />

                                        <div>
                                            <span className="inline-block bg-[#29A8DC1A] text-[#29A8DB] font-bold rounded-full px-4 py-1">
                                                Manage
                                            </span>

                                            <h3
                                                className="mt-4"
                                                style={{
                                                    fontWeight: 600,
                                                    lineHeight: 1.15,
                                                    fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                                }}
                                            >
                                                Bookings & Khata
                                            </h3>

                                            <p className="p-lg text-[#5C5C5C] mt-3">
                                                Take control with smart tools. Manage appointments easily. Track and organize
                                                finances — all in one place.
                                            </p>

                                            <a
                                                href="#"
                                                className="mt-6 inline-flex items-center gap-2 border px-4 py-2 font-bold card"
                                                style={{ borderRadius: '1.75rem', borderColor: 'black' }}
                                            >
                                                Learn More
                                                <img src="assets/arrow.png" className="h-7 w-7" alt="arrow" />
                                            </a>
                                        </div>
                                    </div>
                                </article>






                                <article className="card rounded-3xl bg-white p-6 md:p-8 mb-6 sm:mb-0 sticky top-14 sm:top-28 -mt-12 sm:-mt-20 z-40">
                                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                                        <img
                                            src="assets/features_community.png"
                                            alt="portfolio"
                                            className="rounded-2xl h-auto"
                                            style={{ maxHeight: '28rem' }}
                                        />

                                        <div>
                                            <span className="inline-block bg-[#923CEA1A] text-[#9134EF] font-bold rounded-full px-4 py-1">
                                                Community
                                            </span>

                                            <h3
                                                className="mt-4"
                                                style={{
                                                    fontWeight: 600,
                                                    lineHeight: 1.15,
                                                    fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                                }}
                                            >
                                                Portfolio Website
                                            </h3>

                                            <p className="p-lg text-[#5C5C5C] mt-3">
                                                Build your digital presence. Showcase your work to a wider audience. Connect with others in your industry.
                                            </p>

                                            <a
                                                href="#"
                                                className="mt-6 inline-flex items-center gap-2 border px-4 py-2 font-bold card"
                                                style={{ borderRadius: '1.75rem', borderColor: 'black' }}
                                            >
                                                Learn More
                                                <img src="assets/arrow.png" className="h-7 w-7" alt="arrow" />
                                            </a>
                                        </div>
                                    </div>
                                </article>




                                <article className="card rounded-3xl bg-white p-6 md:p-8 sticky top-20 sm:top-36 -mt-12 sm:-mt-20 z-50">
                                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                                        <img
                                            src="assets/features_finance.png"
                                            className="rounded-2xl h-auto"
                                            alt="finance"
                                            style={{ maxHeight: '28rem' }}
                                        />

                                        <div>
                                            <span className="inline-block bg-[#097E541A] text-[#097D54] font-bold rounded-full px-4 py-1">
                                                Finance
                                            </span>

                                            <h3
                                                className="mt-4"
                                                style={{
                                                    fontWeight: 600,
                                                    lineHeight: 1.15,
                                                    fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                                }}
                                            >
                                                Returnable Grants
                                            </h3>

                                            <p className="p-lg text-[#5C5C5C] mt-3">
                                                Get easy access to interest‑free loans. Use simple tracking systems. Focus on growth without financial stress.
                                            </p>

                                            <a
                                                href="#"
                                                className="mt-6 inline-flex items-center gap-2 border px-4 py-2 font-bold card"
                                                style={{ borderRadius: '1.75rem', borderColor: 'black' }}
                                            >
                                                Learn More
                                                <img src="assets/arrow.png" className="h-7 w-7" alt="arrow" />
                                            </a>
                                        </div>
                                    </div>
                                </article>

                            </div>
                        </div>
                    </section>


                    <section id="partners" class="py-12 md:py-16 lg:py-24">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                            <div class="mb-6 sm:mb-8">
                                <h3 class="font-syne text-[#2E2E2E] text-2xl sm:text-3xl ">
                                    Two
                                    <span class="bg-gradient-to-r from-[#938EFA] to-[#938EFA]/70 bg-clip-text text-transparent">
                                        Membership
                                    </span>
                                    <p>Programs</p>
                                </h3>
                            </div>



                            <div class="mt-6 inline-flex rounded-full bg-[#E1E0FD] p-1" role="tablist"
                                aria-label="Membership tabs">
                                <button className={`tab-btn px-5 py-2 font-bold rounded-full transition ${activeTab === 'users'
                                    ? 'bg-[#38357A] text-white'
                                    : 'text-[#2E2E2E]'
                                    }`} role="tab"
                                    aria-selected="false" aria-controls="panel-users" id="tab-users" data-tab="users" onClick={() => setActiveTab('users')}>
                                    For Users
                                </button>
                                {/* <button
                                    className={`tab-btn px-5 py-2 font-bold rounded-full transition ${activeTab === 'users'
                                        ? 'bg-[#38357A] text-white'
                                        : 'text-[#2E2E2E]'
                                        }`}
                                    onClick={() => setActiveTab('users')}
                                    role="tab"
                                    aria-selected={activeTab === 'users'}
                                ></button> */}

                                <button className={`tab-btn px-5 py-2 font-bold rounded-full transition ${activeTab === 'partners'
                                    ? 'bg-[#38357A] text-white'
                                    : 'text-[#2E2E2E]'
                                    }`}
                                    role="tab" aria-selected="true" aria-controls="panel-partners" id="tab-partners"
                                    data-tab="partners" onClick={() => setActiveTab('partners')}>
                                    For Partners
                                </button>

                                {/* <button
                                    className={`tab-btn px-5 py-2 font-bold rounded-full transition ${activeTab === 'partners'
                                        ? 'bg-[#38357A] text-white'
                                        : 'text-[#2E2E2E]'
                                        }`}
                                    onClick={() => setActiveTab('partners')}
                                    role="tab"
                                    aria-selected={activeTab === 'partners'}
                                ></button> */}
                            </div>



                            <div class="mt-8">



                                {activeTab === 'users' ? (<>
                                    <div id="panel-users" class="tab-panel" role="tabpanel" aria-labelledby="tab-users"
                                        tabindex="0">
                                        <div class="relative rounded-[28px] md:rounded-[36px] bg-white overflow-hidden p-6 md:p-10">


                                            <div class="pointer-events-none absolute inset-0">
                                                <div
                                                    className="absolute right-[6%] top-1/4 h-[520px] w-[520px] rounded-full blur-3xl opacity-60"
                                                    style={{
                                                        background: 'radial-gradient(circle at center, #EAE7FF 0%, #FFFFFF 65%)'
                                                    }}
                                                ></div>

                                            </div>

                                            <div class="relative grid lg:grid-cols-2 gap-10 items-center">

                                                <div class="order-2 lg:order-1 space-y-8">

                                                    <div class="leading-tight">
                                                        <h3 class="text-3xl md:text-4xl font-syne tracking-tight text-[#2E2E2E]">
                                                            Glow Membership & &nbsp;
                                                            <span class="block text-[#938EFA]">It’s Benefits</span>
                                                        </h3>
                                                    </div>


                                                    <div class="space-y-6">
                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-11 w-11 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #EAF9FF 0%, #F6FBFF 100%)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/glow2.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Unlimited Workshop Access
                                                                </p>
                                                                <p class="text-sm text-[#6B6B6B]">Register for as many workshops and
                                                                    enjoy unlimited access to all the recordings!</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-11 w-11 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #FFF2D8 0%, #FFF8EC 100%)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/glow3.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Big Discounts</p>
                                                                <p class="text-sm text-[#6B6B6B]">Enjoy 50% off on paid workshops
                                                                    and 20% discount on all courses!</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-11 w-11 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #FFE7F2 0%, #FFF4FA 100%)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/glow4.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Unlimited Manage</p>
                                                                <p class="text-sm text-[#6B6B6B]">Effortlessly manage endless
                                                                    bookings and khata entries.</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-11 w-11 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #EAF6FF 0%, #F5FBFF 100%)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/glow5.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Unlimited Designs</p>
                                                                <p class="text-sm text-[#6B6B6B]">Use all the Readymade & DIY
                                                                    templates. Get 50% off on Studio services.</p>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <a href="#"
                                                        class="inline-flex items-center gap-3 rounded-full px-6 py-3 font-semibold text-white transition shadow-md hover:shadow-lg w-max"
                                                        style={{ background: "#7872F8" }}>
                                                        Try Glow For Free
                                                        <span
                                                            class="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/90">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-[#7872F8]"
                                                                viewBox="0 0 24 24" fill="currentColor">
                                                                <path
                                                                    d="M13.172 12l-4.95 4.95 1.414 1.414L16 12l-6.364-6.364-1.414 1.414z" />
                                                            </svg>
                                                        </span>
                                                    </a>
                                                </div>


                                                <div class="order-1 lg:order-2 relative flex justify-center lg:justify-end">




                                                    <div class=" p-3 ">
                                                        <img src="assets/glow_main.png" alt="Glow mock"
                                                            class="rounded-[20px] w-full max-w-[520px] h-auto object-contain" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>) : (<>
                                    <div class="tab-panel" role="tabpanel" aria-labelledby="tab-partners"
                                        tabindex="0">
                                        <div class="relative rounded-[28px] md:rounded-[36px] bg-white overflow-hidden p-6 md:p-10">


                                            <div className="pointer-events-none absolute inset-0">
                                                <div
                                                    className="absolute right-1/4 top-1/3 h-[420px] w-[420px] rounded-full blur-3xl opacity-40"
                                                    style={{
                                                        background: 'radial-gradient(circle at center, #E9E7FF 0%, #ffffff 60%)'
                                                    }}
                                                ></div>
                                            </div>

                                            <div class="relative grid lg:grid-cols-2 gap-8 items-center">

                                                <div class="flex justify-center lg:justify-start">
                                                    <div class="bg-white p-3 ">
                                                        <img src="assets/udhyogini_main.png" alt="Udhyogini mock"
                                                            class="rounded-[20px] w-full max-w-[520px] h-auto object-contain" />
                                                    </div>
                                                </div>


                                                <div class="space-y-8">

                                                    <div class="leading-tight">
                                                        <h3 class="text-3xl md:text-4xl font-syne tracking-tight">
                                                            <p class="text-[#938EFA]">Udhyogini – </p>

                                                            <span class="text-[#2E2E2E]">Partner Program</span>
                                                        </h3>
                                                    </div>


                                                    <div class="space-y-6">

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-10 w-10 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #F0EEFF, #E9F3FF)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/udhyogini2.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Custom Benefit Packages</p>
                                                                <p class="text-sm text-[#6B6B6B]">Tailored access to Youvati’s tools
                                                                    &amp; services for your beneficiaries.</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-10 w-10 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #F0EEFF, #E9F3FF)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/udhyogini3.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Exclusive Add-ons</p>
                                                                <p class="text-sm text-[#6B6B6B]">Mentorship, market linkages &amp;
                                                                    government registrations.</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-10 w-10 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #F0EEFF, #E9F3FF)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/udhyogini4.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Impact-Driven Approach</p>
                                                                <p class="text-sm text-[#6B6B6B]">Track progress, measure outcomes,
                                                                    and showcase real impact.</p>
                                                            </div>
                                                        </div>

                                                        <div class="flex items-start gap-4">
                                                            <span
                                                                className="shrink-0 inline-flex h-10 w-10 rounded-full items-center justify-center"
                                                                style={{
                                                                    background: 'linear-gradient(180deg, #F0EEFF, #E9F3FF)',
                                                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                                                                }}
                                                            >
                                                                <img src="assets/udhyogini5.png" className="h-6 w-6" alt="" />
                                                            </span>

                                                            <div>
                                                                <p class="font-semibold text-[#2E2E2E]">Seamless Integration</p>
                                                                <p class="text-sm text-[#6B6B6B]">Flexible onboarding solutions
                                                                    aligned with your program needs.</p>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <a href="#" class="inline-flex items-center gap-3 rounded-full px-6 py-3 font-semibold text-white
                  transition shadow-md hover:shadow-lg"  style={{ background: '#7872F8' }}>
                                                        Partner With Us
                                                        <span
                                                            class="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/90">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-[#7872F8]"
                                                                viewBox="0 0 24 24" fill="currentColor">
                                                                <path
                                                                    d="M13.172 12l-4.95 4.95 1.414 1.414L16 12l-6.364-6.364-1.414 1.414z" />
                                                            </svg>
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>)}








                            </div>
                        </div>
                    </section>

                    <section id="testimonials" className="py-12 md:py-16 lg:py-24 bg-white/50">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
                            <div class="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                                <div>
                                    <div className="mb-6 sm:mb-8">
                                        <h3
                                            className="font-syne text-[#2E2E2E] text-2xl sm:text-3xl"
                                            style={{
                                                fontWeight: 600,
                                                lineHeight: 1.15,
                                                fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                            }}
                                        >
                                            Trusted by{' '}
                                            <span className="bg-gradient-to-r from-[#938EFA] to-[#938EFA]/70 bg-clip-text text-transparent">
                                                15,000+
                                            </span>
                                        </h3>

                                        <p
                                            className="font-syne"
                                            style={{
                                                fontWeight: 600,
                                                lineHeight: 1.15,
                                                fontSize: 'clamp(1.5rem, 1.5vw + 1rem, 2.5rem)'
                                            }}
                                        >
                                            Happy Users
                                        </p>
                                    </div>


                                </div>


                                <div className="flex items-center gap-3">
                                    <button id="t-prev" aria-label="Previous" className="nav-btn h-11 w-11 inline-flex items-center justify-center rounded-full
   bg-white text-[#38357A] ring-1 ring-black/10 shadow transition
   disabled:opacity-40 disabled:pointer-events-none">
                                        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor">
                                            <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                        </svg>
                                    </button>



                                    <button id="t-next" aria-label="Next" className="nav-btn h-11 w-11 inline-flex items-center justify-center rounded-full
           bg-white text-[#38357A] ring-1 ring-black/10 shadow transition
            hover:text-white
           disabled:opacity-40 disabled:pointer-events-none">
                                        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor">
                                            <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
                                        </svg>
                                    </button>
                                </div>

                            </div>

                            <div className="grid lg:grid-cols-[320px,1fr] gap-4 items-stretch">

                                <div className="bg-[#38357A] text-white rounded-2xl p-8 flex flex-col items-center justify-center">
                                    <p className="text-6xl font-extrabold">4.5</p>
                                    <img src="assets/5star.png" className="h-10 w-auto my-4" />
                                    <p className="text-2xl font-bold">User Reviews</p>
                                    <img src="assets/groupimg2.png" className="mt-8 h-20 w-auto" />
                                </div>


                                <div className="relative">
                                    <div id="t-mount" className="grid md:grid-cols-3 gap-1"></div>
                                    <div id="t-dots" className="mt-3 flex gap-2"></div>
                                </div>
                            </div>
                        </div>
                    </section>



                    <section class="py-10 sm:py-12 lg:py-14 bg-[#F6F5FA]">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                            <div class="space-y-1 mb-6 sm:mb-8">
                                <h3 class="font-syne text-[#2E2E2E] text-2xl sm:text-3xl">Youvati Is</h3>
                                <p
                                    class="font-syne text-2xl sm:text-3xl bg-gradient-to-r from-[#938EFA] to-[#938EFA]/70 bg-clip-text text-transparent">
                                    Built To Empower
                                </p>
                            </div>


                            <div class="flex flex-wrap items-center gap-3 sm:gap-4">

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Beauty &amp; Wellness Businesses
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Tailors
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Retailers &amp; Consumer Shops
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Fashion Designers
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Handicraft Artisans
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Manufacturers Of Edible Goods
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Manufacturers Of Non-Edible Goods
                                </a>

                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    Other Service Provider Businesses
                                </a>


                                <a href="#" class="inline-flex items-center rounded-full px-4 sm:px-5 py-2 sm:py-3
        text-sm sm:text-base font-medium text-[#2E2E2E]
        border border-[#D6D5FD] bg-white
        hover:bg-[#938EFA] hover:text-white hover:shadow-md transition">
                                    And You
                                </a>
                            </div>
                        </div>
                    </section>




                    {/* <section className="py-12 md:py-16 lg:py-20 bg-[#F6F5FA]">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <h2 className="text-2xl md:text-3xl font-syne">
                                Frequently Asked <span className="text-[#938EFA]">Questions</span>
                            </h2>

                            <div className="mt-8 grid lg:grid-cols-2 gap-8 items-start">
                                <div className="space-y-4">
                                    {[
                                        {
                                            id: 1,
                                            question: "Is Youvati available in all locations?",
                                            answer:
                                                "We are rapidly expanding and already present in 850+ cities across India.",
                                        },
                                        {
                                            id: 2,
                                            question: "How can individuals benefit from Youvati?",
                                            answer:
                                                "Workshops, courses, branding resources, bookings, khata and more — all in one app.",
                                        },
                                        {
                                            id: 3,
                                            question: "What challenges does Youvati solve?",
                                            answer:
                                                "Digitization, customer acquisition, operations, and access to finance for micro-entrepreneurs.",
                                        },
                                    ].map(item => (
                                        <div key={item.id} className="bg-white rounded-2xl p-6 card">
                                            <button
                                                className={`faq-toggle w-full flex items-center justify-between text-left ${item.id === 1 ? "open" : ""
                                                    }`}
                                                data-faq={item.id}
                                            >
                                                <span
                                                    className="font-bold text-lg"
                                                    style={{ color: "#5C5C5C" }}
                                                >
                                                    {item.question}
                                                </span>
                                                <span className="icon flex items-center justify-center h-10 w-10 rounded-full bg-[#EDEBFE] text-[#38357A]">
                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        className="h-6 w-6"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                    >
                                                        <path strokeLinecap="round" d="M12 5v14" />
                                                        <path strokeLinecap="round" d="M5 12h14" />
                                                    </svg>
                                                </span>
                                            </button>

                                            <div
                                                id={`faq-${item.id}`}
                                                className={`faq-content mt-3 text-[#666] text-sm leading-relaxed ${item.id !== 1 ? "hidden" : ""
                                                    }`}
                                            >
                                                {item.answer}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="flex justify-center">
                                    <img
                                        src="assets/faq.png"
                                        className="max-w-sm w-full h-auto"
                                        alt="FAQ Illustration"
                                    />
                                </div>
                            </div>
                        </div>
                    </section> */}

                    <section className="py-12 md:py-16 lg:py-20 bg-[#F6F5FA]">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <h2 className="text-2xl md:text-3xl font-syne">
                                Frequently Asked <span className="text-[#938EFA]">Questions</span>
                            </h2>

                            <div className="mt-8 grid lg:grid-cols-2 gap-8 items-start">
                                <div className="space-y-4">
                                    {faqs.map((faq, index) => (
                                        <div key={faq.id} className="bg-white rounded-2xl p-6">
                                            <button
                                                onClick={() => handleToggle(index)}
                                                className="w-full flex items-center justify-between text-left"
                                            >
                                                <span className="font-bold text-lg text-[#5C5C5C]">
                                                    {faq.question}
                                                </span>

                                                <span className="icon flex items-center justify-center h-10 w-10 rounded-full bg-[#EDEBFE] text-[#38357A]" style={{ fontSize: "2.1rem" }}>
                                                    {openIndex === index ? "×" : "+"}
                                                </span>
                                            </button>

                                            {openIndex === index && (
                                                <div className="mt-3 text-[#666] text-sm leading-relaxed">
                                                    {faq.answer}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className="flex justify-center">
                                    <img
                                        src="assets/faq.png"
                                        className="max-w-sm w-full h-auto"
                                        alt="FAQ Illustration"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* <style>
				keep the icon centered and animate only rotation 
				.icon svg {
					transition: transform .2s ease;
					transform-origin: 50% 50%;
				}

				.faq-toggle.open .icon svg {
					transform: rotate(45deg);
				}

		
			</style> */}



                    <section id="download" class="py-12 md:py-16 lg:py-14">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div class="rounded-[24px] md:rounded-[32px] bg-[#3F3B88] text-white overflow-hidden">

                                <div
                                    class="flex flex-col p-6 md:p-10 lg:p-0 lg:grid lg:grid-cols-[minmax(220px,360px),1fr,180px] lg:items-center lg:gap-6">


                                    <div class="order-3 lg:order-1 w-full lg:w-auto flex lg:justify-start mt-6 lg:mt-0"
                                        style={{ marginLeft: "-3rem", marginBottom: "-3rem" }}>
                                        <img src="assets/handmockup.png" alt="Youvati app preview"
                                            class="w-auto max-h-64 md:max-h-72 lg:max-h-80 object-contain pt-4" />
                                    </div>


                                    <div class="order-1 lg:order-2 w-full space-y-3 md:space-y-4 text-left lg:px-8">
                                        <h3 class="text-2xl md:text-3xl font-syne leading-tight">
                                            To Achieve Your Goals, There’s Only One Thing You Need.
                                        </h3>
                                        <p class="text-lg md:text-xl font-syne">
                                            Download <span class="text-[#BFC3FF]">Youvati</span>
                                        </p>
                                        <p class="text-white/80 max-w-md">
                                            Scan the QR code to download the app on your phone
                                        </p>
                                    </div>


                                    <div
                                        class="order-2 lg:order-3 flex flex-row lg:flex-col items-center justify-start lg:justify-center gap-4 mt-4 lg:mt-0 pr-0 lg:pr-10">


                                        <div class="h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/y_icon.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


                                        <div class=" h-20 w-20 md:h-24 md:w-24 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('assets/qrcode.png')", backgroundRepeat: "no-repeat", backgroundPosition: "center", position: "relative", backgroundSize: "cover", height: "10rem" }}></div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>




                </main>








                {/* <footer class="bg-white border-t">
                    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                        <div class="flex flex-col lg:flex-row justify-between gap-10">


                            <div class="space-y-4">
                                <img src="assets/youvati_logo.png" alt="Youvati Logo"
                                    class="h-10 w-auto" />
                                <p class="text-sm text-gray-600" style={{ fontWeight: "600" }}>Your
                                    Success Saathi</p>


                                <div class="flex gap-4">
                                    <a href="https://www.facebook.com/youvatiofficial/"
                                        target="_blank"><img src="assets/facebook_icon.png"
                                            class="h-7 w-7" alt="Facebook" /></a>
                                    <a
                                        href="https://www.instagram.com/youvatiofficial?igsh=MXd2aTFkY29laGt5ZQ=="><img
                                            src="assets/insta_icon.png" class="h-7 w-7"
                                            target="_blank" alt="Instagram" /></a>
                                </div>
                            </div>


                            <div
                                class="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-10 text-sm font-medium">
                                <a href="#privacy" class="hover:text-[#38357A]"
                                    style={{ fontWeight: "600" }}>Privacy & Policy</a>
                                <a href="#home" class="hover:text-[#38357A]"
                                    style={{ fontWeight: "600" }}>Home</a>
                                <a href="#terms" class="hover:text-[#38357A]"
                                    style={{ fontWeight: "600" }}>Terms & Condition</a>
                                <a href="#partners" class="hover:text-[#38357A]"
                                    style={{ fontWeight: "600" }}>Partner with us</a>
                                <a href="#about" class="hover:text-[#38357A]"
                                    style={{ fontWeight: "600" }}>About us</a>
                            </div>
                        </div>


                        <div class="mt-8 border-t pt-6 text-xs text-gray-600"
                            style={{ fontWeight: "600" }}>
                            ©2025. Able Edutech Pvt. Ltd. All rights reserved
                        </div>
                    </div>
                </footer> */}

                <Footer />


            </div>


        </>
    )
}

export default Dashbaord;
